import { type CSSProperties } from 'react';
import { EmbeddedBlock } from '@tinct/core-api-models';
import { isBlockPersonalizationEnabled } from '../../../../../utils/is-block-personalization-enabled';

export type BlockOverlayProps = {
  block: EmbeddedBlock;
  isActive: boolean;
};

export function BlockOverlay({
  block,
  isActive,
}: BlockOverlayProps) {
  const enabled = isBlockPersonalizationEnabled(block);
  const borderColor = enabled ? '#6366f1' : '#a3a3a3';
  const borderWidth = isActive ? 3 : 1;

  const overlayStyle: CSSProperties = {
    position: 'absolute',
    inset: 0,
    zIndex: 99997,
    pointerEvents: 'none',
  };

  const frameStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    borderRadius: 8,
    boxShadow: `inset 0 0 0 ${borderWidth}px ${borderColor}`,
    transition: 'box-shadow 0.15s ease',
  };

  return (
    <div
      data-tinct-overlay=""
      data-tinct-block-id={block.id ?? ''}
      style={overlayStyle}
    >
      <div style={frameStyle} />
    </div>
  );
}
